import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";

const AddEventPage = ({ onClose, onSubmit }) => {
  const [eventData, setEventData] = useState({
    lom_name: "",
    event_name: "",
    event_topic: "",
    category: "",
    event_date: "",
    event_time: "",
    duration: "",
    event_location: "",
    last_date: "",
    zone_trainer_id: [],
    created_by: [sessionStorage.getItem("lom")],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [catOptions, setCatOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [loms, setLoms] = useState([]);
  const user_type = sessionStorage.getItem("profession_id");
  useEffect(() => {
    fetchZoneTrainers();
    fetchLoms();
    fetchTopics();
  }, []);
  const handleTrainerChange = (selected) => {
    // Store only the values (not the entire object)
    const selectedValues = selected
      ? selected.map((trainer) => trainer.value)
      : [];
    setEventData((prevState) => ({
      ...prevState,
      zone_trainer_id: selectedValues, // Update only with the values
    }));
  };
  const handleCategoryChange = (selected) => {
    // Store only the selected value, not an array
    setEventData((prevState) => ({
      ...prevState,
      event_topic: selected ? selected.value : "", // If selected, set the value; otherwise, set an empty string
    }));
  };
  const handleLomChange = (selected) => {
    // Store only the selected value, not an array
    setEventData((prevState) => ({
      ...prevState,
      created_by: selected ? selected.value : "", // If selected, set the value; otherwise, set an empty string
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "duration") {
      const parsedValue = parseFloat(value);
      if (parsedValue < 0 || isNaN(parsedValue)) {
        return; // Prevent updates if the value is negative or invalid
      }
    }
    setEventData({ ...eventData, [name]: value });
  };

  const lomoptions = [
    { value: "admin", label: "All" }, // Add this as the first option
    ...loms.map((lom) => ({
      value: lom.lom_id,
      label: lom.lom_name,
    })),
  ];
  const fetchZoneTrainers = async () => {
    try {
      const response = await axios.get("/zone_trainer/get_all");
      setOptions(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  const fetchTopics = async () => {
    try {
      const response = await axios.get("/event_topics/get_all");
      setCatOptions(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  const fetchLoms = async () => {
    try {
      const response = await axios.get("/lom/read");
      setLoms(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  // const catOptions = [
  //   { value: "Category 1", label: "Category 1" },
  //   { value: "Category 2", label: "Category 2" },
  //   { value: "Category 3", label: "Category 3" },
  // ];
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      // POST request to your backend to create a new event
      const response = await axios.post("/events/create", eventData, {
        params: {
          user_type: sessionStorage.getItem("profession_id"),
        },
      });
      console.log("Event added:", response.data);

      Swal.fire({
        icon: "success",
        title: "Event Added",
        text: "The event has been added successfully!",
        confirmButtonText: "Okay",
      });

      onSubmit(); // Refresh events after successful addition
      onClose(); // Close the Add Event popup
    } catch (err) {
      setError(err.response?.data?.error || "Failed to add event");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-4xl shadow-lg">
        <h2 className="text-lg font-bold mb-4">Add New Event</h2>
        {error && <p className="text-red-500">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* LOM Name Dropdown */}
            {/* <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">LOM Name</label>
              <select
                name="lom_name"
                value={eventData.lom_name}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
                required
              >
                <option value="">Select LOM Name</option>
                <option value="general">General</option>
                <option value="lom2">LOM 2</option>
                <option value="lom3">LOM 3</option>
              </select>
            </div> */}
            {/* Program Name Input */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Program Name
              </label>
              <input
                type="text"
                name="event_name"
                value={eventData.event_name}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
                required
              />
            </div>

            {/* Category Dropdown */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Category
              </label>
              <Select
                name="event_topic"
                value={
                  eventData.event_topic
                    ? catOptions.find(
                        (option) => option.value === eventData.event_topic.value
                      )
                    : null
                }
                onChange={handleCategoryChange}
                options={catOptions}
                className="w-full"
                required
              />
            </div>

            {/* Created For */}
            {user_type === "2" || user_type === "1" ? (
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Created For
                </label>
                <Select
                  name="created_by"
                  value={
                    eventData.created_by
                      ? lomoptions.find(
                          (option) =>
                            option.value === eventData.created_by.value
                        )
                      : null
                  }
                  onChange={handleLomChange}
                  options={lomoptions}
                  className="w-full"
                  required
                />
              </div>
            ) : null}

            {/* Event Date */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Event Date
              </label>
              <input
                type="date"
                name="event_date"
                value={eventData.event_date}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
                min={new Date().toISOString().split("T")[0]} // Set the minimum date to today
                required
              />
            </div>

            {/* Event Time */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Event Time
              </label>
              <input
                type="time"
                name="event_time"
                value={eventData.event_time}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
                required
              />
            </div>

            {/* Event Duration */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Event Duration (hrs)
              </label>
              <input
                type="number"
                name="duration"
                value={eventData.duration}
                onChange={handleChange}
                step="0.10" // Allows decimal input
                className="w-full p-2 border rounded-lg"
                required
              />
            </div>

            {/* Event Location */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Event Location
              </label>
              <input
                type="text"
                name="event_location"
                value={eventData.event_location}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
                required
              />
            </div>

            {/* Last Date to Apply */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Last Date to Apply
              </label>
              <input
                type="date"
                name="last_date"
                value={eventData.last_date}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
                min={new Date().toISOString().split("T")[0]} // Set the minimum date to today
                required
              />
            </div>

            {/* Zone Trainers */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Zone Trainers
              </label>
              <Select
                isMulti
                options={options}
                name="zone_trainer_id"
                onChange={handleTrainerChange}
                className="w-full"
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 text-black rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded-lg"
              disabled={loading}
            >
              {loading ? "Adding..." : "Add Event"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEventPage;
